import { responseErrorHandle } from '@/utils/utils';
import { get } from 'lodash';
import {
  checkTimes,
  deleteWageApply,
  downloadEncryptedFile,
  exportActiveTemplate,
  exportDetails,
  exportTask,
  fetchStatusOptions,
  fetchWageApplyDetail,
  fetchWageApplyList,
  fetchWageApplyTimes,
  fetchWageAuditList,
  getBudgetInfo,
  getSalaryFlowList,
  importResult,
  importSubmit,
  ledgerExportFile,
  mainProces,
  processException,
  salaryFlowSetBudget,
  salaryPayment,
  saveWageApply,
  splitPayment,
  submitAnalyzeRes,
  submitWageApply,
  uploadEncryptedFile,
} from '../services';

export default {
  namespace: 'salary',
  state: {
    flowListReal: [],
    flowListInstead: [],
    budgetList: [],
    limitEconomicClassifySwitch: false,
    applyFormNo: '',
  },
  effects: {
    /**
     * 导出任务上传模版
     */
    *exportTask({ payload }, { call }) {
      const result = yield call(exportTask, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 提交解析结果
     */
    *submitAnalyzeRes({ payload }, { call }) {
      const result = yield call(submitAnalyzeRes, payload);
      responseErrorHandle(result);
      return result;
    },
    /**
     * 获取工资申报列表
     */
    *getApplyList({ payload }, { call }) {
      const result = yield call(fetchWageApplyList, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 获取工资申报审批列表
     */
    *getAuditList({ payload }, { call }) {
      const result = yield call(fetchWageAuditList, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 删除工资申报单
     */
    *deleteApply({ payload }, { call }) {
      const result = yield call(deleteWageApply, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 获取工资申报单详情
     */
    *fetchApplyDetail({ payload }, { call }) {
      const result = yield call(fetchWageApplyDetail, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 获取次数
     */
    *fetchApplyTimes({ payload }, { call }) {
      const result = yield call(fetchWageApplyTimes, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 获取状态选项
     */
    *fetchStatusOptions({ payload }, { call }) {
      const result = yield call(fetchStatusOptions, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 导入任务提交
     */
    *importSubmit({ payload }, { call }) {
      const result = yield call(importSubmit, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 导入任务结果
     */
    *importResult({ payload }, { call }) {
      const result = yield call(importResult, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 导出明细
     */
    *exportDetails({ payload }, { call }) {
      const result = yield call(exportDetails, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 上传文件流，获取加密fileId
     */
    *uploadEncryptedFile({ payload }, { call }) {
      const result = yield call(uploadEncryptedFile, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 下载加密文件
     */
    *downloadEncryptedFile({ payload }, { call }) {
      const result = yield call(downloadEncryptedFile, payload);
      return result;
    },
    //下载台账导入失败excel原因表格
    *ledgerExportFile({ payload }, { call }) {
      const result = yield call(ledgerExportFile, payload);
      return result;
    },
    /**
     * 保存申报单
     */
    *saveWageApply({ payload }, { call }) {
      const result = yield call(saveWageApply, payload);
      responseErrorHandle(result);
      return result;
    },
    /**
     * 提交申报单
     */
    *submitWageApply({ payload }, { call }) {
      const result = yield call(submitWageApply, payload);
      responseErrorHandle(result);
      return result;
    },

    /**
     * 申报单下载工资模板
     */
    *exportActiveTemplate({ payload }, { call }) {
      const result = yield call(exportActiveTemplate, payload);
      responseErrorHandle(result);
      return result;
    },

    /*
     * 查询工资支付流水
     */
    *getSalaryFlowList({ payload, index }, { call, put, select }) {
      try {
        const result = yield call(getSalaryFlowList, payload);
        const { paymentFlowROS = [] } = result;
        const list = (paymentFlowROS || []).map((item, index) => {
          // 第一个铁定没有， 从第二个开始
          if (index > 0 && get(paymentFlowROS, `[${index - 1}].accountCode`)) {
            // 上一个的付款账户accountCode
            item.preItemAccountCode = get(paymentFlowROS, `[${index - 1}].accountCode`);
          } else {
            item.preItemAccountCode = '';
          }
          return item;
        });
        yield put({
          type: 'update',
          payload: {
            [index === 1 ? 'flowListReal' : 'flowListInstead']: list || [],
            applyFormNo: result.wageFormCode || '',
          },
        });
        return result;
      } catch (e) {
        console.log(e, '出错了');
        yield put({
          type: 'update',
          payload: {
            [index === 1 ? 'flowListReal' : 'flowListInstead']: [],
            applyFormNo: '',
          },
        });
      }
    },
    *resetData({}, { put }) {
      yield put({
        type: 'update',
        payload: {
          flowListReal: [],
          flowListInstead: [],
          budgetList: [],
          limitEconomicClassifySwitch: false,
          applyFormNo: '',
        },
      });
    },
    /**
     * 查询工资支付流水
     */
    *getBudgetInfo({ payload }, { call, put, select }) {
      try {
        const limitEconomicClassifySwitch = yield select(
          state => state.salary.limitEconomicClassifySwitch,
        );
        const param = { ...payload };
        if (!limitEconomicClassifySwitch) {
          Reflect.deleteProperty(param, 'depExpendEconomicClassifyCodes');
        }
        const result = yield call(getBudgetInfo, param);
        yield put({
          type: 'update',
          payload: {
            budgetList: result || [],
          },
        });
        return result;
      } catch (e) {
        yield put({
          type: 'update',
          payload: {
            budgetList: [],
          },
        });
      }
    },
    // 处理异常
    *processException({ payload }, { call }) {
      return yield call(processException, payload);
    },
    /**
     * 支付流水设置预算
     */
    *salaryFlowSetBudget({ payload }, { call, put }) {
      const result = yield call(salaryFlowSetBudget, payload);
      return result;
    },
    /**
     * 支付流水
     */
    *salaryPayment({ payload }, { call, put }) {
      const result = yield call(salaryPayment, payload);
      return result;
    },
    // 校验申报次数
    *checkTimes({ payload }, { call }) {
      return yield call(checkTimes, payload);
    },
    // 拆分流水
    *splitPayment({ payload }, { call }) {
      return yield call(splitPayment, payload);
    },
    // 拆分流水
    *mainProces({ payload }, { call }) {
      return yield call(mainProces, payload);
    },
  },

  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
